import axios from "axios";
import api from "@/api";

// Cliente da API da área do afiliado. Instância própria, e não a de api/index.ts,
// porque aquela renova o JWT do assinante no 401 e manda para a home no 404 — nada
// disso vale aqui. A base é a mesma do cliente do site.
//
// O 401/403 da sessão é tratado no useAfiliadoApi, que tem o router à mão.
const apiAfiliado = axios.create({
  baseURL: api.defaults.baseURL,
  withCredentials: true,
});

apiAfiliado.interceptors.request.use((config) => {
  if (import.meta.client) {
    const store = afiliadoStore();
    if (store.token) config.headers.Authorization = `Bearer ${store.token}`;
  }
  return config;
});

export default apiAfiliado;
